<template>
  <Modal
    id="AttendanceEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="attendanceForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                    <FormItem :label="$t('attendance.field.id_emp')" name="idEmp">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="form.idEmp"
                              :placeholder="$t('attendance.validate.required.id_emp')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                              :disabled="this.$store.getters.getId === 1 ?  false: true"
                      >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['employeeList']" :value="item['idEmp']">{{ item['nickName'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('attendance.field.check_in')" name="checkIn">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.checkIn" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <!-- <Col span="10">
                <FormItem :label="$t('attendance.name.late')">
                  <Select v-model:value="form.late">
                    <SelectOption :value="true">{{ $t('public.name.yes') }}</SelectOption>
                    <SelectOption :value="false">{{ $t('public.name.no') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              
                <Col span="10">
                    <FormItem :label="$t('attendance.field.check_out')" name="checkOut">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.checkOut" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <!-- <Col span="10">
                <FormItem :label="$t('attendance.name.earlyLeave')">
                  <Select v-model:value="form.earlyLeave">
                    <SelectOption :value="true">{{ $t('public.name.yes') }}</SelectOption>
                    <SelectOption :value="false">{{ $t('public.name.no') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { AttendanceAdd } from "@/api/AttendanceAdd";
import { AttendanceEdit } from "@/api/AttendanceEdit";
import { EmployeeListAll } from "@/api/EmployeeListAll"


export default {
  name: "AttendanceEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idAtt : "",
        idEmp : this.$store.getters.getId === 1 ?  "": this.$store.getters.getId,
        checkIn : "",
        checkOut : "",
      },
      fileList: {
      },
      selectList: {
        employeeList: [],
      },
      validateRules: {
        idAtt: [
          {
            required: true,
            message: this.$t("attendance.validate.required.id_att"),
            trigger: "change",
          },
        ],
        idEmp: [
          {
            required: true,
            message: this.$t("attendance.validate.required.id_emp"),
            trigger: "change",
            type: "number"
          },
        ],
        checkIn: [
          {
            required: true,
            message: this.$t("attendance.validate.required.check_in"),
            trigger: "change",
          },
        ],
        checkOut: [
          {
            required: false,
            message: this.$t("attendance.validate.required.check_out"),
            trigger: "change",
          },
        ],
        late: [
          {
            required: true,
            message: this.$t("attendance.validate.required.late"),
            trigger: "change",
          },
        ],
        earlyLeave: [
          {
            required: false,
            message: this.$t("attendance.validate.required.early_leave"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getEmployeeList();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getEmployeeList();
      this.visible = true;
    },
    submit() {
      this.$refs["attendanceForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new AttendanceAdd();
              break;
            case "edit":
              console.log("edit");
              api = new AttendanceEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    getEmployeeList() {
      const api = new EmployeeListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.employeeList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idAtt : "",
        idEmp : this.$store.getters.getId === 1 ?  "": this.$store.getters.getId,
        checkIn : "",
        checkOut : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>